import http from '@/assets/common/http';

/**
 * 分页查询供应商前端系统菜单
 * 接口：SERVICE_ID 91003 / OTYPE 4；对应表 Supplier_Front_System_Menus
 * 说明：后端 MENU_CODE 为模糊匹配，调用方需自行按前缀二次过滤
 * @param {Object} data 业务参数
 * @param {number} data.PAGESIZE 每页条数（调试工具传 100000 取全量）
 * @param {number} data.PAGEINDEX 页码索引，0 起
 * @param {string} [data.MENU_CODE] 菜单码模糊查询，如 '103'
 * @param {string} [data.DESCRIPTION] 菜单名称模糊查询
 * @returns {Promise<Array>} resolve 形如 [{ TOTAL_COUNT, list: [{ ID, MENU_CODE, DESCRIPTION }] }]；无数据时为空数组；失败时 reject 错误文本
 */
export function getFrontMenus(data) {
  const params = {
    SERVICE_ID: '91003',
    OTYPE: 4,
    ...data,
  };
  return http.post(params);
}

/**
 * 新增一条供应商前端系统菜单记录
 * 接口：SERVICE_ID 91003 / OTYPE 1；写入表 Supplier_Front_System_Menus
 * 说明：后端会先按 MENU_CODE 查重，已存在时返回「已经存在一个菜单ID，请不要重复添加」
 * @param {Object} data 业务参数
 * @param {string} data.MENU_CODE 菜单码（必填），如 '10315'
 * @param {string} data.DESCRIPTION 菜单名称（必填），如 '价格规则'
 * @returns {Promise<*>} 成功时 resolve 后端返回数据；失败时 reject 错误文本
 */
export function addFrontMenu(data) {
  const params = {
    SERVICE_ID: '91003',
    OTYPE: 1,
    ...data,
  };
  return http.post(params);
}



// WEBPACK FOOTER //
// ./src/assets/api/menu.js